<template>
  <div id="app">
    <AppHeader
      :current-route="currentRoute"
      :is-wisdom-community-screen="isWisdomCommunityScreen"
      @routeChanged="navigateTo"
    />
    <router-view />
  </div>
</template>

<script>

// 导入自定义头部组件
import AppHeader from './components/AppHeader.vue'
// 导入 Vue 3 组合式 API 的响应式、计算属性、监听、生命周期钩子
import { ref, computed, watch, onMounted } from 'vue'
// 导入 vue-router 的路由实例和当前路由对象
import { useRouter, useRoute } from 'vue-router'

export default {//export default是 Vue 组件的默认导出对象
  name: 'App', // 组件名
  components: {
    AppHeader // 注册头部组件
  },
  setup() {
    // 获取路由实例和当前路由对象
    const router = useRouter()
    const route = useRoute()
    // 定义响应式变量 currentRoute，保存当前路由名称
    const currentRoute = ref(router.currentRoute.value.name)

    // 监听路由变化，路由切换后自动更新 currentRoute
    router.afterEach((to) => {
      currentRoute.value = to.name // to 是目标路由对象，取其 name 属性
    })

    // 计算属性，判断当前是否为“主仪表盘”页面
    const isMainDashboard = computed(() => {
      return currentRoute.value === 'MainDashboard'
    })

    const isWisdomCommunityScreen = computed(() => {
      return currentRoute.value === 'MainDashboard' || currentRoute.value === 'WisdomCommunityScreen'
    })

    // 路由跳转方法，参数为目标路由名称
    const navigateTo = (routeName) => {
      router.push({ name: routeName }) // 跳转到指定路由
      currentRoute.value = routeName   // 同步更新 currentRoute
    }

    // 滚动条控制逻辑：根据当前路由，决定是否隐藏页面滚动条
    const updateScrollStyle = () => {
      const body = document.body
      const html = document.documentElement

      // 判断当前路由是否为全屏页面（大屏类页面）
      const isFullScreenPage = ['MainDashboard'].includes(route.name)

      if (isFullScreenPage) {
        // 全屏页面时，隐藏滚动条
        body.style.overflow = 'hidden'
        html.style.overflow = 'hidden'
      } else {
        // 其他页面恢复滚动条
        body.style.overflow = ''
        html.style.overflow = ''
      }
    }

    // 生命周期钩子：组件挂载后执行一次滚动条控制
    onMounted(updateScrollStyle)
    // 监听路由对象变化，路由切换时自动执行滚动条控制
    watch(route, updateScrollStyle)

    // 暴露给模板使用的变量和方法
    return {
      currentRoute,                // 当前路由名称
      isMainDashboard,             // 是否为主仪表盘
      isWisdomCommunityScreen,
      navigateTo                   // 路由跳转方法
    }
  }
}
</script>

<style>
/* 全局样式 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #000000;
  color: white; /* 添加全局文字颜色为白色 */
}

#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: transparent;
  color: white; /* 确保应用内所有文字为白色 */
  overflow: hidden;
}

/* 确保所有元素文字颜色为白色 */
* {
  color: white;
}

/* 特殊元素可能需要单独设置 */
h1, h2, h3, h4, h5, h6, p, span, div, button, a {
  color: white;
}

/* 实有人口卡片全局样式 */
.real-population-card {
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  border: none !important;
  color: white !important;
}

.real-population-card h3 {
  color: white !important;
}

.real-population-card .big-number {
  color: white !important;
}

/* 覆盖Element UI卡片样式 */
.el-card {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.el-card__body {
  background-color: transparent !important;
  border: none !important;
  color: white !important;
}
</style>
